import { Link } from 'react-router';
import { moscowDayLabel, moscowTime } from '../../domain/moscowTime';
import { GuestType, PassStatus, parseServerDate, titleBesidePlate, type Pass } from '../../domain/passes';
import { CarGlyph, LinkIcon, Plate, WalkerGlyph, WalkerIcon } from '../../ui/Plate';
import { StatusChip } from '../../ui/StatusChip';
import s from './passRow.module.css';

const DURATION: Record<number, string> = { 1: 'Разовый', 2: 'Временный', 3: 'Постоянный' };

export function passLabel(p: Pass): string {
  if (p.title) return p.title.replace(/\s+[—–-]\s+не задан[аоы]?\s*$/iu, '');
  if (p.guestData?.name) return p.guestData.name;
  if (p.status === PassStatus.WaitingGuest) return 'Гость по ссылке';
  return 'Гость';
}

export function passLine(p: Pass, now = new Date(), withType = false): string {
  const expires = parseServerDate(p.expiresAt);
  let when: string;
  if (p.status === PassStatus.WaitingGuest) when = 'гость ещё не заполнил данные';
  else if (!expires) when = 'бессрочно';
  else {
    const day = moscowDayLabel(expires, now);
    when = day === 'сегодня' ? `до ${moscowTime(expires)}` : `до ${day} ${moscowTime(expires)}`;
  }
  return withType && DURATION[p.durationType] ? `${DURATION[p.durationType]} · ${when}` : when;
}

/** The name line repeats nothing: next to a drawn plate only the model (or a given name) is shown. */
function rowName(p: Pass): string | null {
  const plate = p.guestData?.plateNumber;
  return plate ? titleBesidePlate(p.title, plate) || null : passLabel(p);
}

/**
 * One pass in a list: plate or guest icon, name, a kind glyph with validity, status chip.
 * The chip sits under the text, not beside it: with large system fonts a side chip overlapped the text.
 */
export function PassRow({ pass, withType }: { pass: Pass; withType?: boolean }) {
  const name = rowName(pass);
  const glyph =
    pass.status === PassStatus.WaitingGuest ? null : pass.guestType === GuestType.Pedestrian ? <WalkerGlyph /> : pass.guestData?.plateNumber ? <CarGlyph /> : null;
  return (
    <Link to={`/passes/${pass.id}`} className={s.row}>
      {pass.guestData?.plateNumber ? (
        <Plate value={pass.guestData.plateNumber} />
      ) : pass.status === PassStatus.WaitingGuest ? (
        <LinkIcon />
      ) : (
        <WalkerIcon />
      )}
      <span className={s.text}>
        {name && <span className={s.name}>{name}</span>}
        <span className={s.sub}>
          {glyph}
          {passLine(pass, new Date(), withType)}
        </span>
        <StatusChip status={pass.status} />
      </span>
    </Link>
  );
}
